import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  cancelAndRefundOrderMockEligibleToRefund,
  orderEligibilitiesMockEligibleToRefund,
  orderEligibilitiesMockNotEligibleToRefund,
  orderMockEligibleToRefund,
  orderMockNotEligibleToRefund,
} from '../../../mock/data/index';
import {
  noActiveItineraryWarning,
  orderNotEligibleForRefundWarning,
  servicesNotRefundableWarning,
} from '../../../mock/dictionaries/index';

/**
 * Mocks for refundable order.
 */
export const eligibleToRefundMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefund), createMockData(orderMockNotEligibleToRefund, [], [noActiveItineraryWarning])],
  getOrderEligibilities: [
    createMockData(orderEligibilitiesMockEligibleToRefund, [], [servicesNotRefundableWarning]),
    createMockData(orderEligibilitiesMockNotEligibleToRefund, [], [orderNotEligibleForRefundWarning])
  ],
  cancelAndRefundOrder: [
    {
      mockData: cancelAndRefundOrderMockEligibleToRefund,
      getResponse: () => {
        return new Response(JSON.stringify(cancelAndRefundOrderMockEligibleToRefund), {
          status: 201
        });
      }
    },
    createMockDataWithResponse(orderEligibilitiesMockNotEligibleToRefund, 201)
  ]
};
